import config from "../../../config";
import { getlist, post } from "../../../contexts/apicontexts";
import { normalizeTaskStatus } from "../taskUtils";

const normalizeString = (value) => String(value ?? "").trim();

const normalizeTaskReportItem = (item) => ({
  taskId: Number(item?.taskId ?? item?.TaskId ?? 0),
  ticketId: Number(item?.ticketId ?? item?.TicketId ?? 0),
  ticketNumber: normalizeString(item?.ticketNumber ?? item?.TicketNumber),
  ticketSubject: normalizeString(item?.ticketSubject ?? item?.TicketSubject),
  title: normalizeString(item?.title ?? item?.Title) || "Untitled task",
  description: normalizeString(item?.description ?? item?.Description),
  status: normalizeTaskStatus(item?.status ?? item?.Status),
  priority: normalizeString(item?.priority ?? item?.Priority) || "Low",
  progressPercent: Number(item?.progressPercent ?? item?.ProgressPercent ?? 0),
  dueDate: item?.dueDate ?? item?.DueDate ?? "",
  assignedEmployeeId: Number(item?.assignedEmployeeId ?? item?.AssignedEmployeeId ?? 0),
  assignedUserId: normalizeString(item?.assignedUserId ?? item?.AssignedUserId),
  assignedEmployeeName: normalizeString(item?.assignedEmployeeName ?? item?.AssignedEmployeeName) || "Unassigned",
  assignedEmployeeEmail: normalizeString(item?.assignedEmployeeEmail ?? item?.AssignedEmployeeEmail),
  createdByUserId: normalizeString(item?.createdByUserId ?? item?.CreatedByUserId),
  createdByName: normalizeString(item?.createdByName ?? item?.CreatedByName),
  createdAt: item?.createdAt ?? item?.CreatedAt ?? "",
  updatedAt: item?.updatedAt ?? item?.UpdatedAt ?? "",
  lastActivityAt: item?.lastActivityAt ?? item?.LastActivityAt ?? "",
  lastActionLabel: normalizeString(item?.lastActionLabel ?? item?.LastActionLabel) || "Task Updated",
  lastActorName: normalizeString(item?.lastActorName ?? item?.LastActorName),
  lastNote: normalizeString(item?.lastNote ?? item?.LastNote),
});

const normalizeTaskReportStatusCount = (item) => ({
  status: normalizeTaskStatus(item?.status ?? item?.Status),
  count: Number(item?.count ?? item?.Count ?? 0),
});

const normalizeTaskReportResponse = (response) => ({
  items: Array.isArray(response?.items ?? response?.Items)
    ? (response?.items ?? response?.Items).map(normalizeTaskReportItem)
    : [],
  statusCounts: Array.isArray(response?.statusCounts ?? response?.StatusCounts)
    ? (response?.statusCounts ?? response?.StatusCounts).map(normalizeTaskReportStatusCount)
    : [],
  totalTasks: Number(response?.totalTasks ?? response?.TotalTasks ?? 0),
});

export const fetchTaskReport = async (filters) => {
  const payload = {
    userId: normalizeString(filters?.userId) || null,
    startDate: filters?.startDate || null,
    endDate: filters?.endDate || null,
    status: normalizeString(filters?.status) || null,
  };

  const response = await post(`${config.baseurl}TaskReport/my-tasks`, payload);
  if (response?.status === 200) {
    return normalizeTaskReportResponse(response.data || {});
  }

  throw new Error(response?.message || "Task report could not be loaded.");
};

export const fetchTaskReportStatusOptions = async () => {
  const response = await getlist(`${config.baseurl}TaskReport/status-options`);
  if (response?.status === 200 && Array.isArray(response.data)) {
    return response.data.map((item) => normalizeTaskStatus(item)).filter(Boolean);
  }

  throw new Error("Task report status options could not be loaded.");
};
